import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css'; // Ruta de importación verificada

const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; {new Date().getFullYear()} Escuela Primaria Arturo Guerrero González T. M. Todos los derechos reservados.</p>
      <div className="footer-links">
        <Link to="/terminos" className="footer-link">Términos y Condiciones</Link>
        <span className="footer-separator"> | </span>
        <a href="mailto:admin@primarturogro.edu.mx" className="footer-link">admin@primarturogro.edu.mx</a>
      </div>
    </footer>
  );
};

export default Footer;